import { asArray } from '../utilities/utils'

export default class ShareOptions {
    private copyLinkContainer: Array<HTMLDivElement> = asArray(document.querySelectorAll('[copy-link]'))

    public init(): void {
        if (this.copyLinkContainer != undefined && this.copyLinkContainer.length > 0) {
            this.copyLinkContainer.forEach((div: HTMLDivElement) => {
                const input: HTMLInputElement = div.querySelector('input')
                const copyLinkButton: HTMLButtonElement = div.querySelector('button')
                const copyLinkButtonText: string = copyLinkButton.innerText

                if (input != undefined && copyLinkButton != undefined) {
                    input.value = window.location.href

                    copyLinkButton.addEventListener('click', () => {
                        input.disabled = false
                        input.select()
                        document.execCommand('copy')
                        input.disabled = true

                        copyLinkButton.innerText = 'Link copied'

                        setTimeout(() => {
                            copyLinkButton.innerText = copyLinkButtonText
                        }, 2000)
                    })
                }
            })
        }
    }

    public static newInstance(): ShareOptions {
        return new ShareOptions()
    }
}